// Navigation hover effect "glide" / "glide-bg" (config snippet, navigation): one indicator (.nav-glide) that glides to
// the link the pointer is on and goes back to the active link when the pointer leaves the navigation.
// Position and size come from the link itself (offset*), a ResizeObserver keeps them right while the bar shrinks.
export default function initNaviGlide() {
    const header = document.querySelector('header.navi-fx--glide, header.navi-fx--glide-bg');
    const list = header && header.querySelector('#navBar .navbar-nav');
    if (!list) {
        return;
    }

    const desktop = window.matchMedia('(min-width: 992px)');
    const indicator = document.createElement('span');
    indicator.className = 'nav-glide';
    indicator.setAttribute('aria-hidden', 'true');
    list.appendChild(indicator);

    const items = () => Array.from(list.querySelectorAll(':scope > .nav-item'));
    const activeItem = () => list.querySelector(':scope > .nav-item.active');

    // item null: fade out; animate false: jump there (first placement, resize)
    const place = (item, animate = true) => {
        if (!item || !desktop.matches) {
            indicator.classList.remove('is-visible');
            return;
        }
        const wasVisible = indicator.classList.contains('is-visible');
        const jump = !animate || !wasVisible;
        if (jump) {
            indicator.style.transition = 'none';
        }
        indicator.style.transform = 'translate(' + item.offsetLeft + 'px, ' + item.offsetTop + 'px)';
        indicator.style.width = item.offsetWidth + 'px';
        indicator.style.height = item.offsetHeight + 'px';
        indicator.classList.add('is-visible');
        if (jump) {
            // apply the jump without animation, then give the transition back
            void indicator.offsetWidth;
            indicator.style.transition = '';
        }
    };

    let hovered = null;
    const current = () => hovered || activeItem();

    items().forEach((item) => {
        item.addEventListener('mouseenter', () => {
            hovered = item;
            place(item);
        });
        item.addEventListener('focusin', () => {
            hovered = item;
            place(item);
        });
    });
    list.addEventListener('mouseleave', () => {
        hovered = null;
        place(activeItem());
    });
    list.addEventListener('focusout', (event) => {
        if (!list.contains(event.relatedTarget)) {
            hovered = null;
            place(activeItem());
        }
    });
    // the scroll spy of the anchor navigation (initAnchorNav.js) moved the active entry
    list.addEventListener('navactivechange', () => {
        if (!hovered) {
            place(activeItem());
        }
    });

    // shrinking bar, fonts that arrive late, resized window: set the indicator again without animation
    const resync = () => place(current(), false);
    if (typeof ResizeObserver === 'function') {
        const observer = new ResizeObserver(resync);
        observer.observe(list);
        items().forEach((item) => observer.observe(item));
    }
    window.addEventListener('resize', resync);
    window.addEventListener('load', resync);
    desktop.addEventListener('change', resync);
    resync();
}
